import React from 'react';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { validateCustomerAddressForm } from '../../utils/validators/validateForm';
import { NotificationManager } from 'react-notifications';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';
import axios from 'axios';
import { Radio, Checkbox } from '@material-ui/core';
import { ROLE_CUSTOMER } from '../../utils/config/constants';
import withUser from '../HOC/HOCwithUser.jsx';
import { FormattedMessage, injectIntl } from 'react-intl';
import Geosuggest from 'react-geosuggest';
import { store } from '../../store';
const style = {
    width: '100%',
    height: '100%'
};
class CustomerAddressCreate extends React.Component {
    constructor(props) {
        super();
        this.state = {
            error: '',
            address_line1: '',
            address_line1Error: '',
            building: '',
            buildingError: '',
            road: '',
            roadError: '',
            block: '',
            blockError: '',
            city: '',
            cityError: '',
            state: '',
            stateError: '',
            country: '',
            countryError: '',
            pincode: '',
            pincodeError: '',
            phone: props.userData.phone ? props.userData.phone : '',
            phoneError: '',
            name: props.userData.name ? props.userData.name : '',
            nameError: '',
            emailError: '',
            email: props.userData.email ? props.userData.email : '',
            loader: false,
            pass: false,
            noResponse: false,
            errorMessage: '',
            latitude: '26.0667',
            longitude: '50.5577',
            type_id: 1,
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            addressAdded: false,
            centerLat: 26.0667,
            centerLng: 50.5577,
            is_default: false,
            added: false
        };
    }

    componentDidMount() {
        this.getPlace(this.state.centerLat, this.state.centerLng);
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(position => {
                this.setState(
                    {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    },
                    () => {
                        this.getPlace(
                            position.coords.latitude,
                            position.coords.longitude
                        );
                        return true;
                    }
                );
            });
        } else {
            error => console.log(error);
        }
    }

    submit = params => {
        const {
            address_line1,

            city,
            state,
            country,
            pincode,
            name,
            email,
            phone,
            building,
            block,
            road,
            type_id,
            is_default
        } = this.state;
        if (
            validateCustomerAddressForm(
                {
                    address_line1,
                    city,
                    country,
                    name,
                    email,
                    phone,
                    building,
                    block,
                    road,
                },
                this.handleError
            )
        ) {
            this.setState({ loader: true });
            this.props.addAddressAction(
                {
                    address_line1,
                    city,
                    state,
                    country,
                    zipcode: this.state.pincode,
                    name,
                    email,
                    phone,
                    building,
                    block,
                    road,
                    latitude: this.state.latitude
                        ? this.state.latitude
                        : this.state.centerLat,
                    longitude: this.state.longitude
                        ? this.state.longitude
                        : this.state.centerLng,
                    type_id,
                    is_default
                },
                this.onDone
            );
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="Validation Error"
                    defaultMessage="Validation Error"
                />,
                'Oops!'
            );
        }
    };
    handleError = params => {
        this.setState(params);
    };

    onDone = (success, data) => {
        this.setState({ loader: false });

        if (success) {
            this.props.history.push(`/user/address`);
            NotificationManager.success(data.message, 'Success');
        }
    };
    handleRadioChange = event => {
        this.setState({ type_id: event.target.value });
    };
    renderButton = () => {
        if (this.state.loader) {
            return <CircularProgress />;
        }
        return (
            <Button
                variant="raised"
                color="primary"
                className="jr-btn"
                onClick={this.submit}
            >
                <FormattedMessage id="add" defaultMessage="Add" />
            </Button>
        );
    };
    onMarkerClick = (props, marker, e) => {
        this.setState({
            selectedPlace: props,
            activeMarker: marker,
            showingInfoWindow: true
        });
    };
    onMarkerDragEnd = (coord, index) => {
        const { latLng } = coord;
        const lat = latLng.lat();
        const lng = latLng.lng();

        this.setState({ latitude: lat, longitude: lng }, () => {
            this.getPlace(lat, lng);
        });
    };

    getPlace = async (lat, lng) => {
        var latLng = parseFloat(lat) + ',' + parseFloat(lng);

        const { data } = await axios({
            url: `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latLng}&key=${this.props.settings.constants.GOOGLE_MAP_KEY}`
        });

        if (data.status === 'OK') {
            console.log("****************",data.results[0]);
            if (data.results[0].formatted_address) {
                this.setState({
                    address_line1: data.results[0].formatted_address
                });
            }
            data.results[0].address_components.map(address => {
                if (address.types.includes('country')) {
                    this.setState({ country: address.long_name });
                } 
                else if (address.types.includes('premise')  ||
                address.types.includes('street_number') ||
                address.types.includes('floor')) {
                 this.setState({ building: address.long_name });
                } else if (address.types.includes('route')) {
                    // pincode = address.long_name;
                    this.setState({ road: address.long_name });
                } else if (address.types.includes('block')) {
                    // pincode = address.long_name;
                    this.setState({ block: address.long_name });
                
                } else if (address.types.includes('postal_code')) {
                    // pincode = address.long_name;
                    this.setState({ pincode: address.long_name });
                }  else if (
                    address.types.includes('locality')
                ) {
                    this.setState({ city: address.long_name });
                }
            });
        } else {
            NotificationManager.error(
                <FormattedMessage
                    id="googleApiNotWorking"
                    defaultMessage="Google Api not working, Please add address manually"
                />,
                'Error'
            );
        }
    };
    handleChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };
    handleSelectPlace = event => {
        if (event) {
            this.setState(
                {
                    latitude: event.location.lat,
                    longitude: event.location.lng,
                    centerLat: event.location.lat,
                    centerLng: event.location.lng
                },
                () => {
                    this.getPlace(event.location.lat, event.location.lng);
                }
            );
        }
    };

    render() {
        const {
            address_line1,
            city,
            state,
            country,
            pincode,
            name,
            email,
            phone,
            loader,
            address_line1Error,
            buildingError,
            blockError,
            roadError,
            building,
            block,
            road,
            cityError,
            stateError,
            countryError,
            pincodeError,
            phoneError,
            emailError,
            nameError,
            latitude,
            longitude
        } = this.state;
        const { userData } = this.props;
        const { formatMessage } = this.props.intl;
        return (
            <Card className="col-md-12">
                <div>
                    <h4>
                        <b>
                            <FormattedMessage
                                id="markerNote"
                                defaultMessage="Note: Drag marker on map to fetch location"
                            />
                        </b>
                    </h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div style={{ height: 300 }}>
                            <Map
                                centerAroundCurrentLocation={true}
                                style={style}
                                google={this.props.google}
                                zoom={7}
                                center={{
                                    lat: latitude,
                                    lng: longitude
                                }}
                            >
                                <Marker
                                    position={{
                                        lat: latitude,
                                        lng: longitude
                                    }}
                                    draggable={true}
                                    onDragend={(t, map, coord) =>
                                        this.onMarkerDragEnd(coord)
                                    }
                                />

                                {/* <InfoWindow
                                    onClose={this.onInfoWindowClose}
                                    marker={this.state.activeMarker}
                                    visible={this.state.showingInfoWindow}
                                >
                                    <div>
                                        <h1>{this.state.selectedPlace}</h1>
                                    </div>
                                </InfoWindow> */}
                            </Map>
                        </div>
                    </div>
                </div>
                <div>
                    <Geosuggest
                        suggestItemClassName="autosuggest-places"
                        onSuggestSelect={this.handleSelectPlace}
                        placeholder="Search Address or Drag Marker in Map"
                        country="BH"
                    />
                </div>
                <form
                    className="row"
                    noValidate
                    autoComplete="off"
                    id="address-create"
                >
                    <div className="col-md-4 col-xs-12">
                        <TextField
                            error={nameError ? true : false}
                            helperText={nameError}
                            type="text"
                            name="name"
                            label={formatMessage({
                                id: 'name'
                            })}
                            id="name"
                            fullWidth
                            placeholder={formatMessage({
                                id: 'name'
                            })}
                            InputLabelProps={{
                                shrink: true
                            }}
                            margin="normal"
                            onChange={event => {
                                this.setState({
                                    name: event.target.value,
                                    nameError: ''
                                });
                            }}
                            value={name}
                            //defaultValue={name}
                            disabled={loader ? true : false}
                            title="Enter your name"
                        />
                    </div>
                    <div className="col-md-4 col-xs-12">
                        <TextField
                            error={emailError ? true : false}
                            helperText={emailError}
                            type="email"
                            name="email"
                            label={formatMessage({
                                id: 'email'
                            })}
                            id="email"
                            fullWidth
                            placeholder={formatMessage({
                                id: 'email'
                            })}
                            InputLabelProps={{
                                shrink: true
                            }}
                            onChange={event => {
                                this.setState({
                                    email: event.target.value,
                                    emailError: ''
                                });
                            }}
                            margin="normal"
                            //defaultValue={email}
                            value={email}
                            disabled={loader ? true : false}
                            title="Enter your email"
                        />
                    </div>
                    <div className="col-md-4 col-xs-12">
                        <TextField
                            error={phoneError ? true : false}
                            helperText={phoneError}
                            type="text"
                            name="phone"
                            label="Mobile number without country code"
                            id="phone"
                            fullWidth
                            placeholder="Mobile number without country code"
                            InputLabelProps={{
                                shrink: true
                            }}
                            onChange={event => {
                                this.setState({
                                    phone: event.target.value,
                                    phoneError: ''
                                });
                            }}
                            margin="normal"
                            value={phone}
                            // defaultValue={phone}
                            disabled={loader ? true : false}
                            title="Enter your phone number"
                        />
                    </div>
                    {/* <div className="col-md-4 col-xs-12">
                        
                        <TextField
                            error={address_line1Error ? true : false}
                            helperText={address_line1Error}
                            type="text"
                            name="address_line1"
                            label={formatMessage({
                                id: 'address'
                            })}
                            id="address_line1"
                            fullWidth
                            placeholder={formatMessage({
                                id: 'address'
                            })}
                            InputLabelProps={{
                                shrink: true
                            }}
                            margin="normal"
                            onChange={event => {
                                this.setState({
                                    address_line1: event.target.value,
                                    address_line1Error: ''
                                });
                            }}
                            value={address_line1}
                            // defaultValue={address_line1}
                            disabled={loader ? true : false}
                            title="Enter address line 1"
                        />
                    </div> */}
                    <div className="col-md-4 col-xs-12">
                        {/* <Geosuggest /> */}
                        <TextField
                            error={buildingError ? true : false}
                            helperText={buildingError}
                            type="text"
                            name="building"
                            label={formatMessage({
                                id: 'building/flat'
                            })}
                            id=" building"
                            fullWidth
                            placeholder={formatMessage({
                                id: 'building/flat'
                            })}
                            InputLabelProps={{
                                shrink: true
                            }}
                            margin="normal"
                            onChange={event => {
                                this.setState({
                                    building: event.target.value,
                                    buildingError: ''
                                });
                            }}
                            value={building}
                            // defaultValue={building}
                            disabled={loader ? true : false}
                            title="Building/flat"
                        />
                    </div>
                    <div className="col-md-4 col-xs-12">
                        {/* <Geosuggest /> */}
                        <TextField
                            error={roadError ? true : false}
                            helperText={roadError}
                            type="text"
                            name="road"
                            label={formatMessage({
                                id: 'road'
                            })}
                            id=" road"
                            fullWidth
                            placeholder={formatMessage({
                                id: 'road'
                            })}
                            InputLabelProps={{
                                shrink: true
                            }}
                            margin="normal"
                            onChange={event => {
                                this.setState({
                                    road: event.target.value,
                                    roadError: ''
                                });
                            }}
                            value={road}
                            // defaultValue={road}
                            disabled={loader ? true : false}
                            title="road"
                        />
                    </div>
                    <div className="col-md-4 col-xs-12">
                        {/* <Geosuggest /> */}
                        <TextField
                            error={blockError ? true : false}
                            helperText={blockError}
                            type="text"
                            name="block"
                            label={formatMessage({
                                id: 'block'
                            })}
                            id=" block"
                            fullWidth
                            placeholder={formatMessage({
                                id: 'block'
                            })}
                            InputLabelProps={{
                                shrink: true
                            }}
                            margin="normal"
                            onChange={event => {
                                this.setState({
                                    block: event.target.value,
                                    blockError: ''
                                });
                            }}
                            value={block}
                            // defaultValue={block}
                            disabled={loader ? true : false}
                            title="block"
                        />
                    </div>
                    
                    <div className="col-md-4 col-xs-12">
                        <TextField
                            error={cityError ? true : false}
                            helperText={cityError}
                            type="text"
                            name="city"
                            label={formatMessage({
                                id: 'city'
                            })}
                            id="city"
                            fullWidth
                            placeholder={formatMessage({
                                id: 'city'
                            })}
                            InputLabelProps={{
                                shrink: true
                            }}
                            margin="normal"
                            onChange={event => {
                                this.setState({
                                    city: event.target.value,
                                    cityError: ''
                                });
                            }}
                            value={city}
                            //defaultValue={city}
                            disabled={loader ? true : false}
                            title="Enter address line 2"
                        />
                    </div>
                    {/* <div className="col-md-4 col-xs-12">
                        <TextField
                            error={stateError ? true : false}
                            helperText={stateError}
                            type="text"
                            name="state"
                            label={formatMessage({
                                id: 'state'
                            })}
                            id="state"
                            fullWidth
                            placeholder={formatMessage({
                                id: 'state'
                            })}
                            InputLabelProps={{
                                shrink: true
                            }}
                            margin="normal"
                            onChange={event => {
                                this.setState({
                                    state: event.target.value,
                                    stateError: ''
                                });
                            }}
                            value={state}
                            //defaultValue={state}
                            disabled={loader ? true : false}
                            title="Enter state"
                        />
                    </div> */}
                    <div className="col-md-4 col-xs-12">
                        <TextField
                            error={countryError ? true : false}
                            helperText={countryError}
                            type="text"
                            name="country"
                            label={formatMessage({
                                id: 'country'
                            })}
                            id="country"
                            fullWidth
                            placeholder={formatMessage({
                                id: 'country'
                            })}
                            InputLabelProps={{
                                shrink: true
                            }}
                            margin="normal"
                            onChange={event => {
                                this.setState({
                                    country: event.target.value,
                                    countryError: ''
                                });
                            }}
                            value={country}
                            // defaultValue={country}
                            disabled={loader ? true : false}
                            title="Enter country"
                        />
                    </div>
                    {/* <div className="col-md-4 col-xs-12">
                        <TextField
                            error={pincodeError ? true : false}
                            helperText={pincodeError}
                            type="text"
                            name="pincode"
                            label={formatMessage({
                                id: 'pincode'
                            })}
                            id="pincode"
                            fullWidth
                            placeholder={formatMessage({
                                id: 'pincode'
                            })}
                            InputLabelProps={{
                                shrink: true
                            }}
                            margin="normal"
                            onChange={event => {
                                this.setState({
                                    pincode: event.target.value,
                                    pincodeError: ''
                                });
                            }}
                            value={pincode}
                            //defaultValue={pincode}
                            disabled={loader ? true : false}
                            title="Enter zipcode"
                        />
                    </div> */}
                    {userData.role == ROLE_CUSTOMER && (
                        <div className="col-md-4 row">
                            <div className="col-md-4">
                                <div className="row">
                                    <Radio
                                        checked={this.state.type_id == 1}
                                        onChange={event =>
                                            this.handleRadioChange(event)
                                        }
                                        value={1}
                                    />
                                    <p>
                                        <FormattedMessage
                                            id="home"
                                            defaultMessage="Home"
                                        />
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="row">
                                    <Radio
                                        checked={this.state.type_id == 2}
                                        onChange={event =>
                                            this.handleRadioChange(event)
                                        }
                                        value={2}
                                    />
                                    <p>
                                        <FormattedMessage
                                            id="work"
                                            defaultMessage="Work"
                                        />
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="row">
                                    <Radio
                                        checked={this.state.type_id == 3}
                                        onChange={event =>
                                            this.handleRadioChange(event)
                                        }
                                        value={3}
                                    />
                                    <p>
                                        <FormattedMessage
                                            id="other"
                                            defaultMessage="Other"
                                        />
                                    </p>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="col-md-4">
                        <input type="checkbox" name="hello" />
                        <div className="row align-items-center">
                            <Checkbox
                                checked={this.state.is_default}
                                onChange={this.handleChange('is_default')}
                                value="is_default"
                            />
                            <p>
                                <FormattedMessage
                                    id="setAsOffice"
                                    defaultMessage="Set as Default"
                                />
                            </p>
                        </div>
                    </div>
                    <div className="col-md-12 col-xs-12">
                        <div className="mt-3" />
                        {this.renderButton()}
                    </div>
                </form>
            </Card>
        );
    }
}

const composedComponent = compose(
    GoogleApiWrapper(props => ({
        apiKey: props.settings.constants.GOOGLE_MAP_KEY
    })),

    connect(null, actions)
);
export default composedComponent(withUser(injectIntl(CustomerAddressCreate)));



// WEBPACK FOOTER //
// ./src/components/Customer/CustomerAddressCreate.jsx